import { render, staticRenderFns } from "./AppAllIframe.vue?vue&type=template&id=a1deff7c&scoped=true&"
import script from "./AppAllIframe.vue?vue&type=script&lang=ts&"
export * from "./AppAllIframe.vue?vue&type=script&lang=ts&"
import style0 from "./AppAllIframe.vue?vue&type=style&index=0&id=a1deff7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1deff7c",
  null
  
)

export default component.exports